import StyledButton from "../../common/buttons/StyledButton";
import TextButton from "../../common/buttons/TextButton";
import BaseModal from "../../common/modals/BaseModal/BaseModal";
import ModalCloseButton from "../../common/modals/ModalCloseButton/ModalCloseButton";
import styles from "./AutomatedSystemsConsentModal.module.css";

const strings = {
  title: "Confirm Phone Number Update",
  yes: "Yes",
  no: "No",
  bodyNo: `The Automated Systems Consent has been set to "No". Are you sure you are speaking with the owner of the phone and you would like to set this number to "No"?`,
  bodyYes: `The Automated Systems Consent has been set to "Yes", but this number is currently inactive. Do you want to continue?`,
};

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  onAccept: () => void;
  consentYes: boolean;
};

export default function AutomatedSystemsConsentModal({
  isOpen,
  onRequestClose,
  onAccept,
  consentYes,
}: Props) {
  return (
    <BaseModal
      className={styles.modal}
      label={strings.title}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <div className={styles.header}>
        <div className={styles.title}>{strings.title}</div>
        <ModalCloseButton onClick={onRequestClose} />
      </div>
      <div className={styles.body}>
        {consentYes ? strings.bodyYes : strings.bodyNo}
      </div>
      <div className={styles.footer}>
        <StyledButton className={styles.acceptButton} onClick={onAccept}>
          {strings.yes}
        </StyledButton>
        <TextButton onClick={onRequestClose}>{strings.no}</TextButton>
      </div>
    </BaseModal>
  );
}
